# import BalanceFragment from "../fragments/balance.graphql"

query GetExpenses($company_id: ID!) {
  spend(company_id: $company_id) {
    ...BalanceFragment
  }
}
